import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import * as React from "react";
import { tv } from "tailwind-variants";
import { backgroundSurfaceActiveVariants, backgroundSurfaceHoverVariants, borderActiveVariants, borderHoverVariants, borderOnVariants, textHoverVariants, textOnVariants, } from "../../theme/variants/sharedVariants";
import { cn } from "../../utils";
import { buttonVariants } from "../Button/Button";
const buttonOutlinedDefault = buttonVariants({ variant: "outlined", color: "default" });
export const buttonToggleVariants = tv({
    base: cn(buttonOutlinedDefault, backgroundSurfaceHoverVariants.primary, borderHoverVariants.primary, borderActiveVariants.primary, borderOnVariants.primary, backgroundSurfaceActiveVariants.primary, textHoverVariants.primary, textOnVariants.primary, "data-[state=on]:bg-primary-5"),
    variants: {
        size: {
            md: "px-4 py-3 rounded-lg leading-sm h-10",
            sm: "p-3 py-1.5 rounded-md leading-md h-8",
        },
        icon: {
            true: "flex flex-row items-center justify-center",
            false: "",
        },
        disabled: {
            true: "disabled:bg-gray-4 disabled:border-gray-5 text-gray-8 hover:none pointer-events-none data-[state=on]:opacity-50 cursor-not-allowed",
            false: "",
        },
    },
    compoundVariants: [
        {
            icon: true,
            size: ["sm"],
            className: "size-8 p-0",
        },
        {
            icon: true,
            size: ["md"],
            className: "size-10  p-0",
        },
    ],
    defaultVariants: {
        variant: "outlined",
        size: "md",
    },
});
const ButtonToggle = React.forwardRef(({ className, size, startIcon, endIcon, icon, asChild, children, disabled, ...props }, ref) => {
    const Comp = asChild ? Slot : TogglePrimitive.Root;
    const buttonProps = {
        ref,
        disabled,
        className: cn(buttonToggleVariants({ size, icon, disabled }), className),
        ...props,
    };
    const renderWithIcon = () => {
        const iconSize = size === "sm" ? "!size-4" : "!size-5";
        const iconSizeCanvas = size === "sm" ? "sm" : "md";
        const StartIconComp = () => React.cloneElement(startIcon, { className: cn(iconSize, "mr-2"), size: iconSizeCanvas });
        const EndIconComp = () => React.cloneElement(endIcon, { className: cn(iconSize, "ml-2"), size: iconSizeCanvas });
        return (_jsxs(Comp, { ...buttonProps, children: [startIcon && _jsx(StartIconComp, {}), children, endIcon && _jsx(EndIconComp, {})] }));
    };
    if (startIcon || endIcon)
        return renderWithIcon();
    return _jsx(Comp, { ...buttonProps, children: children });
});
ButtonToggle.displayName = "ButtonToggle";
export default ButtonToggle;
